import { render } from "./previewForBoard.vue?vue&type=template&id=3fb9b7bf&scoped=true&ts=true"
import script from "./previewForBoard.vue?vue&type=script&lang=ts&config=true"
export * from "./previewForBoard.vue?vue&type=script&lang=ts&config=true"

import "./previewForBoard.vue?vue&type=style&index=0&id=3fb9b7bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb9b7bf"]])

export default __exports__